<template>
  <div :class="cssClass" :style="cssStyle"></div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      required: false
    },
    transparent: {
      type: Boolean,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-loading': true,
        'c-loading--transparent': this.transparent,
        ['c-loading--' + this.variant]: this.variant
      };
    },
    cssStyle() {
      let style = {};
      if (this.height) {
        style.height = this.height + 'px';
      }
      return style;
    }
  }
};
</script>
